/**
 * Created by alvinoktavianus on 6/21/17.
 */

import React, { Component } from 'react'
import { connect } from 'react-redux'

import { updatePaymentStatus } from 'actions/billingRedirect'

class BillingRedirect extends Component {
  componentDidMount () {
    let {order_id, status_code, transaction_status} = this.props.location.query
    this.props.dispatch(updatePaymentStatus(order_id, status_code, transaction_status))
  }

  render () {
    return <div />
  }
}

function mapStateToProps () {
  return {}
}

export default connect(mapStateToProps)(BillingRedirect)



// WEBPACK FOOTER //
// ./app/pages/BillingRedirect/BillingRedirect.js